import { useQuery } from '@tanstack/react-query';

import { CAPTAIN_NOTIFICATION_BANNER_QUERY_KEY } from '@/hooks/constants';
import { getCaptainNotificationBannerInfo } from '@/infrastructure/network/data/captain-notification-banner/captain-notification-banner';
import { useOrganizationStore } from '@/store/organization-store';

interface CaptainNotificationBannerArgs {
	isEnabled: boolean;
}

export const useCaptainNotificationBannerQuery = ({ isEnabled }: CaptainNotificationBannerArgs) => {
	const store = useOrganizationStore();

	return useQuery({
		queryKey: [CAPTAIN_NOTIFICATION_BANNER_QUERY_KEY, store.organizationUuid, store.teamLeagueUuid],
		queryFn: () =>
			getCaptainNotificationBannerInfo({
				organizationUuid: store.organizationUuid,
				teamLeagueUuid: store.teamLeagueUuid
			}),
		enabled: !!store.organizationUuid && !!store.teamLeagueUuid && !!isEnabled
	});
};
